import { render, staticRenderFns } from "./PreferenciaTarifaria.vue?vue&type=template&id=32149b35&scoped=true&"
import script from "./PreferenciaTarifaria.vue?vue&type=script&lang=js&"
export * from "./PreferenciaTarifaria.vue?vue&type=script&lang=js&"
import style0 from "./PreferenciaTarifaria.vue?vue&type=style&index=0&id=32149b35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32149b35",
  null
  
)

export default component.exports